/**
 * Выбор раскладки, ОС, формы клавиатуры и пути начала.
 *
 * Один и тот же набор вопросов задают два экрана: первый вход и переход на
 * новый язык тренировки. Разница между ними — только в языке: на первом входе
 * его выбирают, на втором он уже известен. Два списка вариантов разошлись бы
 * при первой же новой раскладке.
 */

import type { KeyboardForm, OsPlatform } from '@type2x/shared-contracts';
import type { StartPath } from '@type2x/feature-personal-workspace';
import type { Translate } from '@type2x/i18n';
import { ChoiceGroup } from '@type2x/ui';
import {
  formOptions,
  layoutOptionsFor,
  platformOptions,
  startOptions,
  type OnboardingChoice,
} from '@type2x/feature-onboarding';

export interface KeyboardChoiceFieldsProps {
  readonly t: Translate;
  readonly choice: OnboardingChoice;
  readonly onChange: (choice: OnboardingChoice) => void;
}

export function KeyboardChoiceFields({
  t,
  choice,
  onChange,
}: KeyboardChoiceFieldsProps): React.JSX.Element {
  return (
    <>
      <ChoiceGroup
        legend={t('onboarding.layout')}
        name="layout"
        value={choice.layoutId}
        options={layoutOptionsFor(choice.language).map((option) => ({
          value: option.value,
          label: t(`onboarding.layoutId.${option.value}`),
        }))}
        onChange={(layoutId) => onChange({ ...choice, layoutId })}
      />

      <ChoiceGroup
        legend={t('onboarding.platform')}
        name="platform"
        value={choice.platform}
        options={platformOptions().map((option) => ({
          value: option.value,
          label: t(`onboarding.platform.${option.value}`),
        }))}
        onChange={(platform: OsPlatform) => onChange({ ...choice, platform })}
      />

      <ChoiceGroup
        legend={t('onboarding.form')}
        name="form"
        value={choice.form}
        options={formOptions().map((option) => ({
          value: option.value,
          label: t(`onboarding.form.${option.value}`),
        }))}
        onChange={(form: KeyboardForm) => onChange({ ...choice, form })}
      />

      <ChoiceGroup
        legend={t('onboarding.startPath')}
        name="start"
        value={choice.start}
        options={startOptions().map((option) => ({
          value: option.value,
          label: t(`onboarding.start.${option.value}`),
        }))}
        onChange={(start: StartPath) => onChange({ ...choice, start })}
      />
    </>
  );
}
